module.exports = __webpack_public_path__ + "img/898f51c.png";